import { render, staticRenderFns } from "./kepuku.vue?vue&type=template&id=ac32b6fa&scoped=true"
import script from "./kepuku.vue?vue&type=script&lang=ts"
export * from "./kepuku.vue?vue&type=script&lang=ts"
import style0 from "./kepuku.vue?vue&type=style&index=0&id=ac32b6fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac32b6fa",
  null
  
)

export default component.exports